import { common } from "../../config/style-configs/common";

export const styles = {
  style: {},
  container: {
    paddingBottom: 10
  },
  errorMessage: common.containerErrorMessage
};
